import Image from "next/image";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useContactModal } from "../../context/ContactModalContext";
import Breadcrumbs from "./BreadCrumbComponent";

const CommonBanner2 = ({ name, className = "", breadcrumbProps }) => {
  const { t } = useTranslation("common");
  const { openModal } = useContactModal();

  return (
    <div
      className={`relative w-full h-[442px] flex items-center justify-center ${className}`}
    >
      {/* Optimized background image */}
      {/* <Image
        src="/banners/commonbanner2.webp"
        alt="prism digital marketing agency Common Banner"
        fill
        priority
        fetchPriority="high"
        quality={75}
        sizes="100vw"
        className="object-cover object-top"
      /> */}
      <Image
        src="/banners/commonbanner2.webp"
        alt="prism digital marketing agency Common Banner"
        fill
        priority
        quality={50}
        sizes="100vw"
        className="object-cover object-top"
      />
      {/* Overlay content */}
      <div className="relative z-10 w-full lg:w-[70%] px-4 md:px-[60px] flex flex-col items-center justify-center text-white">
        <div className="mb-3">
          <Breadcrumbs {...breadcrumbProps} />
        </div>

        <h1 className="m-0 leading-[120%] font-medium text-center text-[36px] sm:text-[40px] lg:text-[55px] w-full break-words capitalize mb-5">
          {name}
        </h1>
        {/* <Link
          href="/contact-digital-marketing-agency#contact-form"
          scroll={false}
        > */}
        <button
          onClick={() => openModal({ trigger: "frame-component8" })}
          className="text-[16px] bg-white text-black rounded-full px-6 py-3 font-medium text-sm cursor-pointer hover:opacity-70 transition"
        >
          {t("btnTxt.getInTouch")}
        </button>
        {/* </Link> */}
      </div>
      {/* Optional dark overlay for readability */}
      <div className="absolute inset-0 bg-black/40 z-0" />
    </div>
  );
};

export default CommonBanner2;
